<rt-dropdown-header>
  @if (showBackButton()) {
    <rt-icon-button
      prefix
      variant="plain"
      size="small"
      shape="square"
      iconName="arrow-back"
      [rtTooltip]="'app.interview.back' | translate"
      (click)="back.emit(); $event.stopImmediatePropagation()"
    />
  }
  <span> {{ heading() }}</span>
  @if (canManageInterviewTemplates()) {
    <rt-icon-button
      suffix
      variant="plain"
      size="small"
      shape="square"
      iconName="settings"
      [routerLink]="['/settings/evaluation_forms']"
      [rtTooltip]="'app.interview.manage_forms' | translate"
    />
  }
</rt-dropdown-header>
